import { createElement } from 'react'
import type { ToolResultTransformer } from '../types'

const RE_REMINDER = /\n*REMINDER:[\s\S]*/

export const fallbackTransformer: ToolResultTransformer = (rawResult) => {
  const cleaned = rawResult.replace(RE_REMINDER, '').trim()

  const summary = cleaned
    ? createElement('span', null, cleaned)
    : createElement('span', { className: 'italic text-muted-foreground/40' }, '(无返回内容)')

  return { summary, raw: rawResult }
}
